import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private TOKEN_KEY = 'authToken';
    private USER_TYPE_KEY = 'userType';
    private USER_LOGIN = 'loginDetails';

    constructor() {

    }

    getToken(): string | null {
        return localStorage.getItem(this.TOKEN_KEY);
    }

    getRole(): string | null {
        return localStorage.getItem(this.USER_TYPE_KEY);
    }

    getAccessScreens(): string[] {
        const screens = this.USER_LOGIN;
        if (!screens) return [];

        try {
            const parsed = JSON.parse(screens);
            const accessString = parsed.employeeDetails?.accessibleScreens || '';
            return accessString.split(',').map((s: string) => s.trim());
        } catch {
            return [];
        }
    }


    isLoggedIn(): boolean {
        return !!this.getToken();
    }

    hasRole(roles: string[]): boolean {
        const userRole = this.getRole();
        return userRole ? roles.includes(userRole) : false;
    }

    logout(): void {
        localStorage.clear();
    }
}
